import { Box } from "@mui/material";
import styled from "styled-components";

import { globalStyle, colors } from "components";

export const Container = styled.div`
  width: 100%;

  .MuiInputBase-root {
    height: 48px;
    width: 100%;
  }

  .input_mui fieldset {
    border-color: ${globalStyle.input.default};
    font-family: ${globalStyle.fontFamily};
    border-width: 2px;
  }

  .input_mui:hover fieldset {
    border-color: ${globalStyle.input.hover};
  }

  .input_mui .Mui-focused fieldset {
    border-color: ${globalStyle.input.focus};
  }

  .input_mui_error fieldset {
    border-color: ${globalStyle.input.error};
    font-family: ${globalStyle.fontFamily};
    border-width: 2px;
  }

  .input_mui_error:hover fieldset {
    border-color: ${globalStyle.input.hover};
  }

  .input_mui_error .Mui-focused fieldset {
    border-color: ${globalStyle.input.focus};
  }

  .css-i4bv87-MuiSvgIcon-root {
    font-size: 18px;
    color: ${colors.neutral_gray_40};
  }
`;

export const ContainerHeader = styled(Box as any)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0;
  margin-bottom: 6px;
`;

export const LabelRequired = styled(Box as any)`
  padding: 0;

  .MuiBadge-root {
    height: 4px;
  }
`;
